import axios from "../../config/axios-interceptor";
import {PROVIDERS} from "./auth.actions";

export const COUNTRIES = 'COUNTRIES';
export const SECTORS = 'SECTORS';

export const getCountries = () => {
    return async dispatch => {
        try {
            const response = await axios.get('Utility/flags');
            dispatch({type: COUNTRIES, payload: response.data});
        } catch (err) {
            console.log(err);
        }
    }
}

export const getSectors = () => {
    return async dispatch => {
        try {
            const response = await axios.get('Utility/sectors');
            dispatch({type: SECTORS, payload: response.data});
        } catch (err) {
            console.log(err);
        }
    }
}
